import { useEffect } from 'react';
import { tracking } from 'App/Tracking';

export type TodoListItemName =
  | 'support-finder'
  | 'daily-boost'
  | 'chat'
  | 'practitioner-matching'
  | 'book-practitioner'
  | 'session-prep'
  | 'wellbeing-measure';

/**
 * Shared impression/click tracking for the homepage to-do list's rows.
 *
 * `shown` lets a row call this unconditionally, before the loading/empty
 * checks that decide whether it renders at all — calling a hook only after
 * those checks would break the rules of hooks. The effect depends on `shown`
 * alone, so a `completed` change doesn't re-fire the impression while the
 * row stays mounted.
 */
export const useTodoListItemTracking = (
  item: TodoListItemName,
  { shown, completed }: { shown: boolean; completed: boolean },
) => {
  useEffect(() => {
    if (!shown) {
      return;
    }

    tracking.track('homepage-todo-list-item-shown', { item, completed });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shown]);

  const trackClicked = () => {
    tracking.track('homepage-todo-list-item-clicked', { item, completed });
  };

  return { trackClicked };
};
